<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-12">
                        <h4 class="m-0 text-dark">Make Return Order.   <strong>[Note: Please search with Merchant]</strong></h4>
                    </div>
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <form>
                                    <div class="row">
                                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label for="title">Merchant</label>
                                                <v-select name="hub_id"
                                                    v-model="search.merchant_id"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= merchantList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12" v-if="authUser.role_id <= 2">
                                            <div class="form-group">
                                                <label for="title">{{ $t('globalTrans.hub') }}</label>
                                                <v-select name="hub_id"
                                                    v-model="search.hub_id"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= hubList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label for="start_date">Start Date</label>
                                                <input type="date" id="start_date" v-model="search.start_date" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label for="end_date">End Date</label>
                                                <input type="date" id="end_date" v-model="search.end_date" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <button class="btn btn-info btn-sm" type="submit" @click.prevent="searchData" style="margin-top:28px;"><i class="fa fa-search"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header" v-if="makeReturBtn">
                                <div class="row">
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                            <label for="date">Rider <span class="text-danger" title="Required">*</span></label>
                                            <v-select name="rider_id"
                                                v-model="form.rider_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= riderList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                            <label for="date">Status <span class="text-danger" title="Required">*</span></label>
                                            <select v-model="form.status" class="form-control">
                                                <option :value="25">Return On way to Merchant</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                            <label for="date">Barcode Type or Scan</label>
                                            <input type="text" class="form-control" v-model="itemId" @keyup.enter="keepOrder" placeholder="Scan barcode or type order id and press enter"> 
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                        <div class="mt-30">
                                            <button class="btn btn-danger float-right btn-sm ml-2" @click="makeReturn"> Make Return</button>
                                            <b style="margin-left:10px; font-size:18px">Total:{{ totalParcel }}</b>
                                            <b style="margin-left:10px; font-size:18px">Scaned:{{ form.order_ids.length }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <span v-for="(orderId, index) in form.order_ids" :key="index" class="btn btn-sm btn-warning mb-1 mr-1">
                                    {{ orderId }}
                                </span>
                            </div>
                            <div class="card-body">
                                <b-overlay :show="loader">
                                    <div class="table-responsive">
                                        <table id="exportPdfTable" class="table table-bordered table-striped table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Order ID</th>
                                                    <th>Merchant</th>
                                                    <th>Order Date</th>
                                                    <th>Customer</th>
                                                    <th>Price (BDT)</th>
                                                    <th>Collected (BDT)</th>
                                                    <th>Service Charge</th>
                                                    <th>Return Charge</th>
                                                    <th>Area Charge</th>
                                                    <th>Weight Charge</th>
                                                    <th>COD</th>
                                                    <th>Amount</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(order, index) in listData" :key="index">
                                                    <td>{{ order.id }}</td>
                                                    <td @click="orderLog(order.logs)">{{ order.merchant ? order.merchant.business : '' }}</td>
                                                    <td>{{ order.date | dateformat }}</td>
                                                    <td>{{ order.name }}<br/>{{ order.mobile }}</td>
                                                    <td>{{ order.price }}</td>
                                                    <td>{{ order.collected }}</td>
                                                    <td>{{ order.service_charge }}</td>
                                                    <td>{{ order.return_charge }}</td>
                                                    <td>{{ order.area_charge }}</td>
                                                    <td>{{ order.weight_charge }}</td>
                                                    <td>{{ order.cod }}</td>
                                                    <td>{{ order.amount }}</td>
                                                    <td><span :class="'status-'+order.status">{{ getStatus(order.status) }}</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
        <!-- /.content -->
        <div v-if="orderLogModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-info text-white">
                        <h5 class="modal-title text-center w-100">Order Log</h5>
                        <button type="button" class="close" aria-label="Close" @click="cancelModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-bordered table-sm">
                            <tr>
                                <th>Action By</th>
                                <th>Action</th>
                                <th>Date & Time</th>
                            </tr>
                            <tr v-for="(log, index) in order_logs" :key="index">
                                <td>{{ log.operation_by }}</td>
                                <td>{{ log.operation }}</td>
                                <td>{{ log.date | dateformat }} at {{ log.date | timeformat }}</td>
                            </tr>
                        </table>                              
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-danger" @click="cancelModal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import config from '@/config'
    import moment from 'moment'
    import 'jspdf-autotable'
    export default {
        name:'ReturnForm',
        data () {
            return {   
                orderLogModal: false,
                loader: false,             
                makeReturBtn: false,             
                orders:[],           
                listData:[],
                totalParcel: 0,
                itemId: '',
                search: {
                    merchant_id: '',
                    hub_id: '',
                    start_date: moment().subtract(30,'d').format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD')
                },
                form: {
                    rider_id: 'Select',
                    status: 25,
                    order_ids: []
                },
                params: {
                    merchant_id : this.$route.query.merchant_id,
                    start_date : this.$route.query.start_date,
                    end_date : this.$route.query.end_date
                }
            }
        },
        created(){
            this.getOrders();
        },
        computed : {
            merchantList () {
                return this.$store.state.commonObj.merchantList
            },
            hubList () {
                return this.$store.state.commonObj.hubList
            },
            authUser () {
                return this.$store.state.authUser
            },
            riderList () {
                if (this.authUser.role_id == 7) {
                    return this.$store.state.commonObj.riderList.filter(el => el.hub_id === this.authUser.hub_id)
                }
                
                return this.$store.state.commonObj.riderList
            }
        },
        methods:{
            // select(orderId) {
            //     const tmpOrder = this.form.order_ids.indexOf(orderId)
            //     if (tmpOrder > -1) {
            //         this.form.order_ids.splice(tmpOrder, 1)                   
            //     } else {
            //         this.form.order_ids.push(orderId)
            //     }      
            // },
            searchData () {
                this.getOrders()
            },
            async getOrders(){    
                this.totalParcel = 0    
                this.loader = true  
                const params = this.authUser.role_id == 7 ? Object.assign({}, this.search, { hub_id: this.authUser.hub_id }) : this.search
                const response = await config.getData('/hub/return/returnable', params)
                this.loader = false
                if (response.success){
                    this.totalParcel = response.data.length
                    this.listData = response.data
                    this.makeReturBtn = (this.search.merchant_id != 0 && this.totalParcel > 0) ? true : false
                } else {
                    this.listData = []
                    this.makeReturBtn = false
                } 
            },
            keepOrder() {
                let skuList = this.itemId.split(" ")
                if(skuList.length > 1) {
                    skuList.map(item => {
                        if(this.listData.find(el => el.id === parseInt(item))) {
                            this.form.order_ids.push(item)
                        }
                    })
                } else {
                    
                    const tmpItem = this.listData.find(el => el.id === parseInt(this.itemId))
                    if (typeof tmpItem !== 'undefined') {
                        this.form.order_ids.push(this.itemId)
                        this.listData = this.listData.filter(el => el.id !== parseInt(this.itemId))
                        this.totalParcel -= 1
                    } else {
                        this.$toast.error({
                            title: 'Error',
                            message: 'Sorry, parcel not found',
                            color: '#dc3545'
                        })
                    } 
                } 
                this.itemId = ''
            },
            removeRow(itemId){
                this.form.order_ids = this.form.order_ids.filter(el => parseInt(el) !== parseInt(itemId))
            },
            async makeReturn () {
                if(this.form.order_ids.length == 0) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Please scan first then make return',
                        color: '#dc3545'
                    }) 
                    return true;
                }
                this.loader = true
                const formData = Object.assign(this.form, { merchant_id: this.search.merchant_id, hub_id: this.authUser.role_id == 7 ? this.authUser.hub_id : this.search.hub_id })
                const isHubExist = this.checkValidation(formData)
                if (isHubExist) {
                    const response = await config.postData('/hub/return/store', formData)
                    this.loader = false
                    if (response.success) {
                        this.$toast.success({
                            title: 'Success',
                            message: 'Retrurn maked successfully',
                            color: '#218838'
                        }) 
                        this.$router.push('/hub-return-list')
                    } else {
                        this.$toast.error({
                            title: 'Error',
                            message: 'Sorry, something went wrong',
                            color: '#dc3545'
                        }) 
                    }
                }
            },    
            getStatus (status) {
                const tmpStatus = this.$store.state.statusList.find(tmp => tmp.id == status)
                return tmpStatus.text
            },
            orderLog (logs) {
                this.order_logs = logs 
                this.orderLogModal = true
            },
            cancelModal () {
                this.orderLogModal = false
            },
            checkValidation (data) {
                if (data.order_ids.length == 0) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Please select order',
                        color: '#dc3545'
                    }) 
                    return false
                }
                if (data.hub_id == 0) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Please select hub',
                        color: '#dc3545'
                    }) 
                    return false
                }
                this.loader = false
                return true
            }
        }
    }
</script>

<style scoped>
    .d-inline {
        display: inline-block;
        padding-left: 3px;
    }
</style>